import { createFileRoute, notFound } from "@tanstack/react-router";
import ServiceAreaCityPage from "@/pages/ServiceAreaCityPage";
import { getServiceAreaCity } from "@/data/serviceAreas";
import { canonicalUrl } from "@/lib/site";

export const Route = createFileRoute("/service-areas/$slug")({
  beforeLoad: ({ params }) => {
    if (!getServiceAreaCity(params.slug)) throw notFound();
  },
  head: ({ params }) => {
    const city = getServiceAreaCity(params.slug);
    if (!city) return {};
    const url = canonicalUrl(`/service-areas/${city.slug}`);
    return {
      meta: [
        { title: city.title },
        { name: "description", content: city.metaDescription },
        { property: "og:title", content: city.title },
        { property: "og:description", content: city.metaDescription },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: city.title },
        { name: "twitter:description", content: city.metaDescription },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: () => <ServiceAreaCityPage slug={Route.useParams().slug} />,
});
